module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_innlandet_pos.8cf55518.svg";